// extracted by mini-css-extract-plugin
export default {"aboutUs":"AboutUsComponent_aboutUs__fPm8i"};